import React from 'react';
import PropTypes from 'prop-types';
import noPhoto from '../../../assets/img/imperial_tobacco.png';

const ArticleImage = ({image}) => {
  const style = {
    backgroundImage: `url(${image || noPhoto})`,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundSize: 'cover',
    width: '40%',
    height: 200,
  };

  return (
    <div className="align-right" style={style}/>
  );
};

ArticleImage.propTypes = {
  image: PropTypes.string,
};

export default ArticleImage;



// WEBPACK FOOTER //
// ./src/components/common/article/article-image.jsx